// HaInstance endpoints — list + create only. Backend exposes no
// GET-by-id, so the operator UI relies on the list + a client-side
// .find for any "selected" affordance.

import { request, type ApiResponse } from "../client";
import type { HaInstanceCreate, HaInstanceOut } from "../types/haInstance";

export const haInstances = {
  list: (
    accountSlug: string,
    tenantSlug: string,
  ): Promise<ApiResponse<HaInstanceOut[]>> =>
    request<HaInstanceOut[]>(
      "GET",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}/ha-instances`,
    ),

  create: (
    accountSlug: string,
    tenantSlug: string,
    body: HaInstanceCreate,
  ): Promise<ApiResponse<HaInstanceOut>> =>
    request<HaInstanceOut>(
      "POST",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}/ha-instances`,
      body,
    ),
};
